/**
 * NOTE: the order here effects sorting.
 */
export enum AccessDeniedReason {
  MissingSchoolID = 'MissingSchoolID',
  SchoolLicensesNotDistributed = 'SchoolLicensesNotDistributed',
  SchoolLicensesStartEndDatesNotSet = 'SchoolLicensesStartEndDatesNotSet',
  SchoolLicensesStartInFuture = 'SchoolLicensesStartInFuture',
  SchoolLicensesNotAvailable = 'SchoolLicensesNotAvailable',
}

/**
 * An array containing all the values from the enum.
 *
 * This array is *readonly* and *frozen*:
 * - **readonly**: will lead to compile time errors if you try to modify.
 * - **frozen**: will lead to runtime errors if the readonly type is bypassed (example: 'array as any').
 */
export const accessDeniedReasons: readonly AccessDeniedReason[] = Object.freeze(
  Object.values(AccessDeniedReason)
);

/**
 * Sorts enums based on their placement in the enum definition. Sorts null to be at the end of the array.
 * This is used to guarantee that a reason value popped from an array will be the furthest along the process of
 * being granted access.
 */
export function accessDeniedReasonSort(a: AccessDeniedReason | null, b: AccessDeniedReason | null): number {
  if (a === b) {
    return 0;
  }
  if (a == null) {
    return 1;
  }
  if (b == null) {
    return -1;
  }
  return accessDeniedReasons.indexOf(a) - accessDeniedReasons.indexOf(b);
}

